/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Groups
// ====================================================

export interface Groups_groups {
  __typename: "Group";
  id: string;
  name: string;
}

export interface Groups {
  groups: Groups_groups[];
}

export interface GroupsVariables {
  client: string;
}
